import "../../../styles/popupNotificationModal.scss";

import Icon, {iconTypes} from "./Icon";

import Modal from "./Modal";
import PropTypes from "prop-types";
import React from "react";

export default class PopupNotificationModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onConfirm = this.onConfirm.bind(this);
    }

    onConfirm(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.confirm(this.props.notification);
    }

    render() {
        const {
            localization,
            notification,
            deviceType,
            width,    
        } = this.props;

        return (
            <Modal onCloseModal={this.onConfirm} width={deviceType==="xs"? width : undefined}>
                <div className="popup-notification-modal" style={{maxWidth: deviceType==="xs"?width:"500px",marginBottom:"10px"}} >
                    <h2 style={{color: "#e63332" }}>{localization.text("dashboard", "importantMessage")}</h2>
                    <h2>{notification.subject}</h2>
                    <div className="body attention">
                        <div>
                            {notification.body}
                        </div>
                        <div>
                            <Icon type={iconTypes.calendarWarning}/>
                        </div>
                    </div>
                    
                    <div className="hr"/>
                    <div className="button-wrapper">
                        <button className="btn primary block" onClick={this.onConfirm}>{localization.text("dashboard", "confirmRead")}</button>
                    </div>
                </div>
            </Modal>
        );
    }
}

PopupNotificationModal.propTypes = {
    notification: PropTypes.object.isRequired,
    confirm: PropTypes.func.isRequired,
    localization: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
};